import { apiClient } from '../const';

const withQuery = (params) => {
  const cleaned = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    cleaned[key] = value;
  });
  return cleaned;
};

export const normaliseApiError = (error) => {
  const data = error?.response?.data;
  if (data && typeof data === 'object') {
    const code = data.code || data.error_code;
    const message = data.message || data.error || 'Something went wrong';
    return {
      code: code || 'UNKNOWN_ERROR',
      message,
      mobile_results: Array.isArray(data.mobile_results) ? data.mobile_results : null,
      data,
    };
  }
  return {
    code: 'NETWORK_ERROR',
    message: error?.message || 'Network error',
    mobile_results: null,
  };
};

export const fetchCampaigns = async ({ limit = 10, offset = 0, status = '', kind = '' } = {}) => {
  const body = withQuery({ limit, offset, status, kind });
  const res = await apiClient.post('/admin/notifications/campaigns/list', body, {
    skipBodyWrap: true,
  });
  return res.data;
};

export const createCampaign = async (payload) => {
  const res = await apiClient.post('/admin/notifications/campaigns', payload, {
    skipBodyWrap: true,
  });
  return res.data;
};

export const fetchCampaignById = async (campaignId) => {
  const res = await apiClient.get(`/admin/notifications/campaigns/${campaignId}`);
  return res.data;
};

export const fetchCampaignRecipients = async ({
  campaignId,
  limit = 10,
  offset = 0,
} = {}) => {
  const body = withQuery({ limit, offset });
  const res = await apiClient.post(
    `/admin/notifications/campaigns/${campaignId}/recipients`,
    body,
    { skipBodyWrap: true },
  );
  return res.data;
};

export const cancelCampaign = async (campaignId) => {
  const res = await apiClient.post(
    `/admin/notifications/campaigns/${campaignId}/cancel`,
    {},
    { skipBodyWrap: true },
  );
  return res.data;
};

export const fetchAudiences = async () => {
  const res = await apiClient.get('/admin/notifications/audiences');
  return res.data;
};

export const startCampaignFromTemplate = async ({ template_id, audience, mobiles }) => {
  const payload = { template_id, audience };
  if (audience === 'mobiles' && Array.isArray(mobiles)) {
    payload.mobiles = mobiles;
  }
  const res = await apiClient.post(
    '/admin/notifications/campaigns/from-template',
    payload,
    { skipBodyWrap: true },
  );
  return res.data;
};

export const fetchTemplates = async () => {
  const res = await apiClient.get('/admin/notifications/templates');
  return res.data;
};

export const fetchTemplateById = async (templateId) => {
  const res = await apiClient.get(`/admin/notifications/templates/${templateId}`);
  return res.data;
};

export const createTemplate = async (formData) => {
  const res = await apiClient.post('/admin/notifications/templates', formData, {
    skipBodyWrap: true,
  });
  return res.data;
};

export const updateTemplate = async (templateId, formData) => {
  const res = await apiClient.put(`/admin/notifications/templates/${templateId}`, formData, {
    skipBodyWrap: true,
  });
  return res.data;
};

export const deleteTemplate = async (templateId) => {
  const res = await apiClient.delete(`/admin/notifications/templates/${templateId}`);
  return res.data;
};

/** POST /admin/notifications/inbox — body: { limit, offset } */
export const fetchInboxNotifications = async ({ limit = 50, offset = 0 } = {}) => {
  const body = withQuery({ limit, offset });
  const res = await apiClient.post(
    '/admin/notifications/inbox',
    body,
    { skipBodyWrap: true },
  );
  return res.data;
};

/** GET /admin/notifications/inbox/unread-count */
export const fetchInboxUnreadCount = async () => {
  const res = await apiClient.get('/admin/notifications/inbox/unread-count');
  return res.data;
};

/** POST /admin/notifications/inbox/:id/read */
export const markInboxNotificationRead = async (id) => {
  const res = await apiClient.post(
    `/admin/notifications/inbox/${id}/read`,
    {},
    { skipBodyWrap: true },
  );
  return res.data;
};

/** POST /admin/notifications/inbox/read-all */
export const markInboxReadAll = async () => {
  const res = await apiClient.post(
    '/admin/notifications/inbox/read-all',
    {},
    { skipBodyWrap: true },
  );
  return res.data;
};

// Optional legacy direct-query endpoint. Frontend gracefully handles absence.
export const fetchLegacyCommonNotifications = async () => {
  try {
    const res = await apiClient.get('/admin/notifications/legacy-common');
    return res.data;
  } catch (error) {
    // Caller inspects null to show \"Direct-query endpoint unavailable\".
    return null;
  }
};

